import { useEffect, useRef } from 'react';
import { useLocation,useNavigate  } from 'react-router-dom';


import api from '../../../apis';


import { setLogout } from '../../../hooks/handleUserLocalStorage';


const PgActivate = () => {
    // const [cookies, setCookie, removeCookie] = useCookies(['user']);
    const formRef = useRef(null);
    const location = useLocation();
    const navigate = useNavigate();
  
    // Parse the query string
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    

    const handleSubmit = async (event:any) => {
        event.preventDefault(); // Prevent default form submission behavior

        let result = await api.userActivate({token});
        if (result != false && result.status == 0) {
            alert("Account activated");
            // removeCookie('user', { path: '/' });
            setLogout();
            navigate('/login');
            //window.location.href = '/login';
        }
    };

      // Use useEffect to submit the form when the component mounts
    useEffect(() => {
        if (formRef.current) {
            formRef.current.requestSubmit(); // Triggers form submission programmatically
        }
    }, []);

    return (
        <>  <form ref={formRef} onSubmit={handleSubmit}>
        {/* <input type="text" name="example" placeholder="Enter text" />
        <button type="submit">Submit</button> */}
      </form></>
    );
};

export default PgActivate;
